import { mergeSx } from "src/utils/styles";
import { centerContent, columnFlex, flex1, gap1 } from "src/styles/sx";
import { Box, Typography } from "@mui/material";
import i18n from "i18next";
import { useNavigate } from "@tanstack/react-router";
import { capitalize } from "../../utils/strings";
import { AavoButton } from "./buttons/AavoButton";

export const PageNotFound = () => {
	const navigate = useNavigate();

	const goBackToMainPage = () => {
		void navigate({ to: "/" });
	};

	return (
		<Box sx={mergeSx(columnFlex, flex1, centerContent, gap1)}>
			<Typography>{i18n.t("page_not_found")}</Typography>
			<AavoButton color={"primary"} onClick={goBackToMainPage}>
				{capitalize(i18n.t("go_back_to_main_page"))}
			</AavoButton>
		</Box>
	);
};
